import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { Plus } from 'lucide-react'
import { columns } from './columns'
import { DataTable } from './data-table'
import { useSystemVersions } from '@/hooks/useSystemVersions'
import { Skeleton } from '@/components/ui/skeleton'
import { SystemVersionEditDialog } from './SystemVersionEditDialog'

export default function SystemVersionsPage() {
  const [showAddDialog, setShowAddDialog] = useState(false)
  const { systemVersions, isLoading, isError, mutate } = useSystemVersions()

  if (isError) {
    return (
      <div>
        <div className="text-center text-destructive">
          Error loading system versions. Please try again later.
        </div>
      </div>
    )
  }

  if (isLoading) {
    return (
      <div>
        <Skeleton className="h-8 w-[200px] mb-4" />
        <Skeleton className="h-[400px] w-full" />
      </div>
    )
  }

  return (
    <div>
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">APP版本管理</h1>
          <p className="text-muted-foreground mt-2">管理APP版本更新</p>
        </div>
        <Button onClick={() => setShowAddDialog(true)}>
          <Plus className="mr-2 h-4 w-4" />
          新增版本
        </Button>

        <SystemVersionEditDialog
          open={showAddDialog}
          onOpenChange={setShowAddDialog}
          onSuccess={() => mutate()}
        />
      </div>

      <div className="h-4" />

      <Card>
        <CardContent className="p-6">
          <DataTable
            columns={columns}
            data={systemVersions || []}
            meta={{ reloadData: () => mutate() }}
          />
        </CardContent>
      </Card>
    </div>
  )
}
